module.exports = __webpack_public_path__ + "img/maintenance.4fd03b78.png";